import React from "react";
import { Box, styled } from "@mui/material";

const Loader = styled("div")({
  "--d": "40px", // radius of the circle
  width: "6px", // dot size
  height: "6px",
  borderRadius: "50%",
  color: "rgb(53 53 243)",
  boxShadow: `
    calc(1*var(--d))      calc(0*var(--d))      0 0,
    calc(0.866*var(--d))  calc(0.5*var(--d))    0 1px,
    calc(0.5*var(--d))    calc(0.866*var(--d))  0 3px,
    calc(0*var(--d))      calc(1*var(--d))      0 3px,
    calc(-0.5*var(--d))   calc(0.866*var(--d))  0 4px,
    calc(-0.866*var(--d)) calc(0.5*var(--d))    0 5px,
    calc(-1*var(--d))     calc(0*var(--d))      0 6px,
    calc(-0.866*var(--d)) calc(-0.5*var(--d))   0 7px
  `,
  animation: "spinDots 1s infinite steps(15)",

  "@keyframes spinDots": {
    "100%": { transform: "rotate(1turn)" },
  },
});

export default function DotLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
      }}
    >
      <Loader />
    </Box>
  );
}
